import DashboardLayout from "../layouts/dashboard";

import DashboardVideoIndexPage from "../views/dashboardVideo";
import DashboardVideoCreatePage from "../views/dashboardVideo/dashboardVideoCreate";
import DashboardVideoUpdatePage from "../views/dashboardVideo/dashboardVideoUpdate";
import DashboardVideoShowPage from "../views/dashboardVideo/dashboardVideoShow";

import { auth } from "./routerHelper";

const routes = {
  path: "/",
  element: <DashboardLayout />,
  children: [
    {
      path: "dashboardVideos",
      element: auth(<DashboardVideoIndexPage />),
    },
    {
      path: "dashboardVideo/create",
      element: auth(<DashboardVideoCreatePage />),
    },
    {
      path: "dashboardVideo/update/:dashboardID",
      element: auth(<DashboardVideoUpdatePage />),
    },
    {
      path: "dashboardVideo/show/:dashboardID",
      element: auth(<DashboardVideoShowPage />),
    },
  ],
};

export default routes;
